// extracted by mini-css-extract-plugin
module.exports = {"goal-period-section":"ProgressGoalPeriodList--goal-period-section--2ZCYr","goalPeriodSection":"ProgressGoalPeriodList--goal-period-section--2ZCYr"};